import { chakra } from '@plurall/elo-v3';

import { backdropRecipe, contentRecipe, labelRecipe } from './global-loader.recipe';

export const GlobalLoaderBackdropFactory = chakra('div', backdropRecipe);
export const GlobalLoaderContentFactory = chakra('div', contentRecipe);
export const GlobalLoaderLabelFactory = chakra('p', labelRecipe);
